var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconServiceType = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.677,
    height: 10.814,
    viewBox: "0 0 14.677 10.814",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_label_outline_24px",
    d: "M14.3,5.649A1.54,1.54,0,0,0,13.042,5l-8.5.008A1.543,1.543,0,0,0,3,6.545V14.27a1.543,1.543,0,0,0,1.545,1.537l8.5.008a1.54,1.54,0,0,0,1.259-.649l3.376-4.758L14.3,5.649ZM13.042,14.27h-8.5V6.545h8.5l2.742,3.862Z",
    transform: "translate(-3 -5)",
    fill: "#727272"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconServiceType);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-service-type.9a2665d459bd9f020d39fcd6dd02317f.svg";